import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $MultiBanners = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};

  & > *:last-child {
    margin-bottom: ${spacing('lg')};
  }
`;
